/* Dress To "Recently viewed" (sections/dt-recently-viewed.liquid).
   Keeps the last product handles in localStorage (this browser only), then loads each product's /products/<handle>.js
   and draws a simple card. The last photo of every product is its color swatch, so the hover photo is the second one. */
(function () {
  'use strict';
  var KEY = 'dt_recent_v1', KEEP = 16;
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function read() { try { var a = JSON.parse(window.localStorage.getItem(KEY)); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function write(a) { try { window.localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) { /* storage off: nothing to remember */ } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function card(p) {
    var imgs = p.images || [];
    var a = imgs[0] || p.featured_image, b = imgs.length > 2 ? imgs[1] : null;
    var alt = esc(p.title);
    var sw = imgs.length > 1 ? imgs[imgs.length - 1] : null;
    var sku = (p.variants && p.variants[0] && p.variants[0].sku) || '';
    var pic = function (src, cls, altText) {
      return '<img class="dth-card__img' + cls + '" src="' + sized(src, 540) + '" srcset="' + sized(src, 360) + ' 360w, ' + sized(src, 540) + ' 540w, ' + sized(src, 720) + ' 720w" sizes="(min-width: 990px) 24vw, (min-width: 750px) 33vw, 62vw" alt="' + altText + '" loading="lazy" width="720" height="1080">';
    };
    var price = p.compare_at_price && p.compare_at_price > p.price
      ? '<s class="dth-card__was">' + money(p.compare_at_price) + '</s> <span class="dth-card__sale">' + money(p.price) + '</span>'
      : (p.price_varies ? 'From ' : '') + money(p.price);
    return '<li><article class="dth-card dth-card--simple"><div class="dth-card__content">' +
      '<a class="dth-card__gallery" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (a ? pic(a, '', alt) : '') + (b ? pic(b, ' dth-card__img--alt', '') : '') + '</a>' +
      '<div class="dth-card__info">' + (sw ? '<span class="dth-card__dot" style="background-image: url(\'' + sized(sw, 60) + '\')" aria-hidden="true"></span>' : '') +
      '<h3 class="dth-card__h"><a class="dth-card__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a></h3>' +
      (sku ? '<p class="dth-card__ref">Ref: ' + esc(sku) + '</p>' : '') +
      '<p class="dth-card__price">' + price + '</p></div></div></article></li>';
  }

  function init(section) {
    if (!section || section.dataset.dtReady) return;
    section.dataset.dtReady = '1';
    var handle = section.dataset.handle, max = Number(section.dataset.max) || 8;
    var list = read().filter(function (h) { return h && h !== handle; });
    write([handle].concat(list).slice(0, KEEP));
    var show = list.slice(0, max);
    if (!show.length) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    Promise.all(show.map(function (h) {
      return fetch(root + 'products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(function (p) { return p && p.available; });
      if (!items.length) return;
      var ul = section.querySelector('[data-dt-recent-list]');
      ul.innerHTML = items.map(card).join('');
      section.hidden = false;
      var prev = section.querySelector('[data-dt-go="-1"]'), next = section.querySelector('[data-dt-go="1"]');
      var sync = function () {
        if (!prev || !next) return;
        prev.disabled = ul.scrollLeft <= 2;
        next.disabled = ul.scrollLeft >= ul.scrollWidth - ul.clientWidth - 2;
      };
      [prev, next].forEach(function (btn) {
        if (btn) btn.addEventListener('click', function () { ul.scrollBy({ left: ul.clientWidth * 0.8 * Number(btn.dataset.dtGo), behavior: REDUCE.matches ? 'auto' : 'smooth' }); });
      });
      ul.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      window.requestAnimationFrame(sync);
    });
  }

  function boot() { document.querySelectorAll('[data-dt-recent]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
